<template>
  <div class="">
    <img @click="back" data-v-24d6c286="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA6CAMAAAAQoC6jAAAAxlBMVEUAAADR1+fT2OjT2OfT2OXU2ujS1+fU2ejU2ujV2enT2OnU2ujT2OjS1+fS1+fS1+fU2ejR2OjU2OfU2OjV2ejW2ufV2ujU2efV2unT2ejV2OfU2efT2ubT2+nW3Obb2+3U2efV2uj///82Omn8/P3W2+nP1OXS2OdQU3yMj6nN0+WIi6b5+vzv8fff4+7R1ubj5/Dz9Pnt7/bo6/NDR3Ll6PH3+PqQkqzY3euQk6w6P2yanbT19vqRk62WmLBITHalp7ygorj3N9ErAAAAInRSTlMA8vzZE4D2sHtILaOe9+rpycTDuah1bmpnV1U1KSIeDoGd5tYlqQAAAmlJREFUWMO9mOdyIjEMgE0JJRBIb6QQsUhgll22wBEIJe//UsfB5HQ3sSOHku8nw3xjr2wVKyP5cql6nqtnLNRz59VSOa8cyd8UC6FGorYVItRhoXjj4my8FBDbQRJHvmfFj+IkaCMWXhqC7viSNAWxBw54cUCaLo+/8h2RpuEInBkNSdORfXmniAMfvoU/QDy1LPIuq8cRfJtorLN3Jt816QFsxUDTteHzhZjAliQYfvqQVyH2YWv6GF7977snwSca6f5f32NWx7ATsc4+KiYnx0OOTI59RziGnRnj38A8Eb6BgTewYP430pPaUNRDMPCevpp93XRp3nRx43sIyTPd07TV6oKBXqu18E3JgsKHtbBqXiDMWx2Tsbf6eQomhrqyzqdZ8i1bWxsNvpklUVA2vxLeYgDgYGTfL7AQ4O1KeIF9EIySj+/LhVLPJ20PBKOjD7z2ybMq844lI/vsey6rkk5ANDr6INElVcE+yEbBxx+xos4oAgejkw8iOlM58kE2TqbTiewDn3KqxkG2GyedNO1M2GcPc11lHIQwTTuddAoOwoybcO4udNpyb7PlrsuW5aCs4zt5/xOUrkNQhGPD54/Po3BsVgdb9r3yeZQONl89wcdG4eqVMXDxsVFIDpy+BB8bhfTFCVb0sdGeYLkECD7ByCWAi5Tgk4xcpFTFUkZnm/pmMs5tZVQq9DNj7hEKvbUVWS7mYGS2WJoXWBSapZF1mhCapX21c819N5x7b4n33bQfdqzYffA57Gi2+/B44PGWaW4zgDd/5ImAaVQ/HjFGnpXRxyNGtfEDzyz2h6BaxkLti4eg38yjFL29qJTDAAAAAElFTkSuQmCC" alt="" class="gbline">

    <div data-v-65d98e59="" class="registerDiv">
      <form data-v-65d98e59="" class="van_wrap_div van-form">
        <div data-v-65d98e59="" class="inputline">
            <img v-if="name" data-v-65d98e59="" src="data:image/png;base64,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" alt="" class="iconImg">
          <img
          v-else
            data-v-65d98e59=""
            src="data:image/png;base64,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"
            alt=""
            class="iconImg"
          />
          <div data-v-65d98e59="" class="van-cell van-field">
            <div class="van-cell__value van-cell__value--alone van-field__value">
              <div class="van-field__body"><input v-model="name" type="text" :placeholder="$t('请输入用户名')" class="van-field__control" /></div>
            </div>
          </div>
        </div>
        <div data-v-65d98e59="" class="inputline">
            <img v-if="password" data-v-65d98e59="" src="data:image/png;base64,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" alt="" class="iconImg">
          <img
          v-else
            data-v-65d98e59=""
            src="data:image/png;base64,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"
            alt=""
            class="iconImg"
          />
          <div data-v-65d98e59="" class="van-cell van-field">
            <div class="van-cell__value van-cell__value--alone van-field__value">
              <div class="van-field__body"><input :type="show1?'text':'password'" v-model="password" placeholder="请设置密码" class="van-field__control" /></div>
            </div>
          </div>
          <img
          @click="show1=!show1"
          v-if="!show1"
            data-v-65d98e59=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAQCAYAAAB3AH1ZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBMUJFQjczQjc3RjUxMUVCOTUwMEEwOTA2Mzg5MENFRSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBMUJFQjczQzc3RjUxMUVCOTUwMEEwOTA2Mzg5MENFRSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkExQkVCNzM5NzdGNTExRUI5NTAwQTA5MDYzODkwQ0VFIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkExQkVCNzNBNzdGNTExRUI5NTAwQTA5MDYzODkwQ0VFIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+tl/b1gAAAdlJREFUeNq8lc8rRFEUx9+MHxH5UTZ+NUVZKJKfUzKUBgv/gAXJBrtJKdYkOwtCUTbCjoVIkvzYSBOzkOT3jwUaEWkU4vut8+p2MzPSG6c+896977z7Pfe8c+7Ydr2HbsMwpsE+aAF3RmQtBfSAauCxIYAT3OTKwyeQAQIREo8FZyBTxvd2/Axo0W2AmAiIR4ElRZzWzwCmwJoyWQa2QJyF4tzQMqhV5rjREQbwBRrBsfKwAlyDfAvEc8A5cCtzHDdQ2y4Tb6AInCpOaeAAzADHH4TTwYSsqab9EhSIphGtPGAmbpSCNK1J4Itj8rno9ww+5D2mOEGEqkBHiOxdgE9zwC7gNQ/sSBH+h/mBk9mxS9RHmrhfdjJkgdg4cEmLq5+X7Z/KAMq1F1ZBNtgGXSARNGsLhDP6toMk0CldxfNlXfMrZgAPykQ3qDcLROwVzGptycJqlQBJm3SNaaytSfCizAWkDXvVtem4CUok7VdBdlSjBeABi5rPI5iXe2atUnZuaIU+COZAMvCZRRjOfKBQ7ln58XLVDxtmzmxtLygNt7D9F+IORZzW94M47V12ZxqzmmVFAC5tPBrCd1gbO60IYEH+qnkA1UmtBLNbOXJZ7XtgJdzi3wIMAFHsatkFQHpDAAAAAElFTkSuQmCC"
            class="eye"
          />
          <img v-else @click="show1=!show1" data-v-65d98e59="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUCAYAAADskT9PAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2OTgxNThCQTc3RjUxMUVCQUE2NkFDQTRENzIyOUJCOCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2OTgxNThCQjc3RjUxMUVCQUE2NkFDQTRENzIyOUJCOCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjY5ODE1OEI4NzdGNTExRUJBQTY2QUNBNEQ3MjI5QkI4IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjY5ODE1OEI5NzdGNTExRUJBQTY2QUNBNEQ3MjI5QkI4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YlrzBwAAAj1JREFUeNq8lU1IVFEUx+dNUzERjiQKQ6HWwrCojS7MNtUomkIgwSiFFQgtIgcLGmnlWgkKxIW4iGhUUHARFJkfIJII00Ro0KpFFJRfoW4UitH/kb9wu7x333sGHvjBO/eee86999xznpXOfAm4SA6YBiugE4y62NeBJNddAusm41DAXRrAeX5fBlHwy8FW5l4reg0YNjkPetjAO01PGGyTmj7t5tzLBn6CWUVvB4dt7MKgTdEnDDf1zwYsXvMFg11CWxO3sdHHHhn8XQTXJLa8gatghBMvQQv4oy34ABZBAfVnoALkcUPyQJsU+wXwySbwQcZopF4d0h5iM7hC5z84VgoegmOKnXzfM5wwHzwHT8BnjhWCGXBcsdu0UIZH8fEd5GpOHnNDZwL/J19BCnRo48vghMU+EGYaan04/kYnf5maIo+PWuQNuC43sLtggw1kwGHBOkvsLDjCQMWgnOk6BQ7wIKf5aH87+BoE9RJcFEvphHLV89opFvhgpJ6zPq9eqqsS9PN2VCkDH9U+cNImeJ/kCEztIbjIFnjP2+nS5jK8zZ2AYZaZGvw+uMv8OkkEVIEY+76TZNm8bmjjcgMRCdqrlZiUXI/L6W6BVTAGxsEauOmyRnJ/R9EPgaGglh/5cTx1cVQCXtiMp2xyrYus61YbU5B/rBhzEveQ29uGuWYP6xMs23O7nVDKYdLH44oa5vI8+lginhuHKq8Mc2N+ne11A3M242nwdj82kGUjecB2LLTyd+67X2wLMADd/G2WCkBhlgAAAABJRU5ErkJggg==" class="eye">
        </div>
        <div data-v-65d98e59="" class="inputline">
            <img v-if="password1" data-v-65d98e59="" src="data:image/png;base64,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" alt="" class="iconImg">
          <img
          v-else
            data-v-65d98e59=""
            src="data:image/png;base64,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"
            alt=""
            class="iconImg"
          />
          <div data-v-65d98e59="" class="van-cell van-field">
            <div class="van-cell__value van-cell__value--alone van-field__value">
              <div class="van-field__body"><input :type="show2?'text':'password'" v-model="password1" :placeholder="$t('请再次输入密码')" class="van-field__control" /></div>
            </div>
          </div>
          <img
          @click="show2=!show2"
          v-if="!show2"
            data-v-65d98e59=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAQCAYAAAB3AH1ZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBMUJFQjczQjc3RjUxMUVCOTUwMEEwOTA2Mzg5MENFRSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBMUJFQjczQzc3RjUxMUVCOTUwMEEwOTA2Mzg5MENFRSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkExQkVCNzM5NzdGNTExRUI5NTAwQTA5MDYzODkwQ0VFIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkExQkVCNzNBNzdGNTExRUI5NTAwQTA5MDYzODkwQ0VFIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+tl/b1gAAAdlJREFUeNq8lc8rRFEUx9+MHxH5UTZ+NUVZKJKfUzKUBgv/gAXJBrtJKdYkOwtCUTbCjoVIkvzYSBOzkOT3jwUaEWkU4vut8+p2MzPSG6c+896977z7Pfe8c+7Ydr2HbsMwpsE+aAF3RmQtBfSAauCxIYAT3OTKwyeQAQIREo8FZyBTxvd2/Axo0W2AmAiIR4ElRZzWzwCmwJoyWQa2QJyF4tzQMqhV5rjREQbwBRrBsfKwAlyDfAvEc8A5cCtzHDdQ2y4Tb6AInCpOaeAAzADHH4TTwYSsqab9EhSIphGtPGAmbpSCNK1J4Itj8rno9ww+5D2mOEGEqkBHiOxdgE9zwC7gNQ/sSBH+h/mBk9mxS9RHmrhfdjJkgdg4cEmLq5+X7Z/KAMq1F1ZBNtgGXSARNGsLhDP6toMk0CldxfNlXfMrZgAPykQ3qDcLROwVzGptycJqlQBJm3SNaaytSfCizAWkDXvVtem4CUok7VdBdlSjBeABi5rPI5iXe2atUnZuaIU+COZAMvCZRRjOfKBQ7ln58XLVDxtmzmxtLygNt7D9F+IORZzW94M47V12ZxqzmmVFAC5tPBrCd1gbO60IYEH+qnkA1UmtBLNbOXJZ7XtgJdzi3wIMAFHsatkFQHpDAAAAAElFTkSuQmCC"
            class="eye"
          />
          <img v-else @click="show2=!show2" data-v-65d98e59="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUCAYAAADskT9PAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2OTgxNThCQTc3RjUxMUVCQUE2NkFDQTRENzIyOUJCOCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2OTgxNThCQjc3RjUxMUVCQUE2NkFDQTRENzIyOUJCOCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjY5ODE1OEI4NzdGNTExRUJBQTY2QUNBNEQ3MjI5QkI4IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjY5ODE1OEI5NzdGNTExRUJBQTY2QUNBNEQ3MjI5QkI4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YlrzBwAAAj1JREFUeNq8lU1IVFEUx+dNUzERjiQKQ6HWwrCojS7MNtUomkIgwSiFFQgtIgcLGmnlWgkKxIW4iGhUUHARFJkfIJII00Ro0KpFFJRfoW4UitH/kb9wu7x333sGHvjBO/eee86999xznpXOfAm4SA6YBiugE4y62NeBJNddAusm41DAXRrAeX5fBlHwy8FW5l4reg0YNjkPetjAO01PGGyTmj7t5tzLBn6CWUVvB4dt7MKgTdEnDDf1zwYsXvMFg11CWxO3sdHHHhn8XQTXJLa8gatghBMvQQv4oy34ABZBAfVnoALkcUPyQJsU+wXwySbwQcZopF4d0h5iM7hC5z84VgoegmOKnXzfM5wwHzwHT8BnjhWCGXBcsdu0UIZH8fEd5GpOHnNDZwL/J19BCnRo48vghMU+EGYaan04/kYnf5maIo+PWuQNuC43sLtggw1kwGHBOkvsLDjCQMWgnOk6BQ7wIKf5aH87+BoE9RJcFEvphHLV89opFvhgpJ6zPq9eqqsS9PN2VCkDH9U+cNImeJ/kCEztIbjIFnjP2+nS5jK8zZ2AYZaZGvw+uMv8OkkEVIEY+76TZNm8bmjjcgMRCdqrlZiUXI/L6W6BVTAGxsEauOmyRnJ/R9EPgaGglh/5cTx1cVQCXtiMp2xyrYus61YbU5B/rBhzEveQ29uGuWYP6xMs23O7nVDKYdLH44oa5vI8+lginhuHKq8Mc2N+ne11A3M242nwdj82kGUjecB2LLTyd+67X2wLMADd/G2WCkBhlgAAAABJRU5ErkJggg==" class="eye">
        </div>
        <div v-if="password" data-v-65d98e59="" class="inputline">
            <img v-if="code" data-v-65d98e59="" src="data:image/png;base64,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" alt="" class="iconImg">
            <img v-else data-v-65d98e59="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpDRUI5NDQ1Mjc4MTgxMUVCODlCOUYyMTlDNTQ4RjNFQiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpDRUI5NDQ1Mzc4MTgxMUVCODlCOUYyMTlDNTQ4RjNFQiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkNFQjk0NDUwNzgxODExRUI4OUI5RjIxOUM1NDhGM0VCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkNFQjk0NDUxNzgxODExRUI4OUI5RjIxOUM1NDhGM0VCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+MWQKDAAAAphJREFUeNq0l+9rjWEYx5/zOF6YhReyGOLFJDMk5gVbrFlI0ZRfaRkvmPKGl3jhR/sP5keJV5g3KJmfS7FN0vxY1CaSspZ4oWRZ2eZz6Xrq6fTcP57jnKs+ndM5931/7/s81/e6r5O5cu1O4BmzoArqYCXMhhAG4SU8hlfwZffOTeOuxTIO4QyshlOwznODz+Ek3GcDY6ZBoWWBufAEnqYQlVgFHXL6q+0dC9IKb4HPsCbIP5bAAOIHfIVl4K2gcHEe8eMu4a0yMCh8nEa8xSRcDjeD4sVZxCtzhTNqhzRxHdbDWIo5rxEP48K1UOEx8Tc8UC/vgkdQCk3Q7zE/C9vjPn6jWZgU+yEy+w8YiX+JV/+9chL51UpgGoxCGzQmrPcdymQHZRbRQB/BV9dRtFr9UmQjfQbh6bAwVMPbojTPZCqxfFcnwjWFSFlOWAGTPIfXZrXg/4+gvLTCHGj2nFYtwvMcg2w3zUTN7J+wOUo0jygPNcV9hZdCu/pe5r6DZQbRUduiMvmTQzj+3MSrU7VofFDvzzCcdIplzaFQL3FbrI29Fw9vhMswHxoQHTE89wbLmr0i3OUQPqbPMh77oB46DXMqHZWwW4S7HcJSiS4lfN6ZVKc5rfi3x7HmQxEego+OgXu0BGYd1pKq9MLxfIclKUPN2iMeFjikzVxVguAEkK7lGyxyrHOUvPgT3U639eSuWAxSg+/CcpiM4A5tk3y7lotB7Kcb14au33PyBiVt1MhpczuQAThYxA6kFdEuU891AU4UQbRNbWntMs9oIhXspHA4t7qZ7HFO/X0PZuYpKLapR/BZ2n8SfXrVbYP3KQQlw/dK4TGJBh43k9wwN9Qq4s9qzeYVuqnoT1uvNoEi9DbKXFv8FWAAN2OsUZg5cNMAAAAASUVORK5CYII=" alt="" class="iconImg">
            <div data-v-65d98e59="" class="van-cell van-field">
                <div class="van-cell__value van-cell__value--alone van-field__value">
                    <div class="van-field__body"><input type="text" v-model="code" :placeholder="$t('请输入验证码')" class="van-field__control"></div>
                </div>
            </div>

            <img style="cursor: pointer" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="获取验证码..." class="yzm" />
            </div>
        <!---->
        <div data-v-65d98e59="" class="sumbtns" :class="{submitActive:name&&password&&password1&&code}">
          <button @click="register" data-v-65d98e59="" type="submit" class="van-button van-button--info van-button--normal van-button--block">
            <div data-v-65d98e59="" class="van-button__content"><span data-v-65d98e59="" class="van-button__text"> 注册并下载APP </span></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'login',
  data() {
    return {
      registerInfo: {},
      loginInfo: {},
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      index: 0,
      infoType: 1, //0 是登陆 1是注册
      psw1: true,
      psw2: true,
      psw3: true,
      pid: '',
      name:'',
      password:'',
      password1:'',
      code:'',
      show1:false,
      show2:false
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.infoType = query.type;
    }
    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
  },
  methods: {
    back(){
      window.history.go(-1)
    },
    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
      that.changIndex();
      that.loginInfo = {};
      that.registerInfo = {};
      this.psw1 = true;
      this.psw2 = true;
      this.psw3 = true;
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    register() {
      let that = this;
        var info={}
    //   let info = that.registerInfo;
    //   console.log(info);
      if (!that.name || that.name.length < 6) {
        that.showTost(0, ' 用户名长度6~16位，以字母或数字组合！');
        return;
      }
      if (!that.password || that.password.length < 6) {
        that.showTost(0, '请输入正确的密码长度，最少6位！');
        return;
      }
      if(that.password!=that.password1){
        that.showTost(0, '两次密码不一样！');
        return;
      }
      // if (!info.confirmPass || info.confirmPass != info.password) {
      //   that.$parent.showTost(0, '两次密码不一致！');
      //   return;
      // }
      // if (!info.realname || info.realname.length < 2) {
      //   that.$parent.showTost(0, '请输入您的真实姓名!');
      //   return;
      // }

      // if (!info.paypassword || info.paypassword.length < 6) {
      //   that.$parent.showTost(0, '请输入正确的支付密码长度，最少6位！');
      //   return;
      // }
      let code = that.code;
      if (!code) {
        that.$parent.showTost(0, that.$t('请输入验证码')+'！');

        return;
      }
      if (code.toUpperCase() != that.imgLis[that.index]) {
        that.showTost(0, '验证码错误！');
        that.code = null;
        that.changIndex();
        return;
      }
    info.name=this.name
    info.realname=this.name
    info.password=this.password
    info.paypassword=this.password
    info.code=this.code
      that.$parent.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      console.log(info);
      that.$apiFun.register(info).then(res => {
        that.showTost(1, res.message);
        if (res.code == 200) {
          localStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.go();
        }
        that.$parent.hideLoading();
      }).catch(err=>{
        that.showTost(2, "注册失败");
        that.$parent.hideLoading();
      })
    },
    go(){
      this.$router.push('/')
    },
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.showTost(0, '请输入您的账号和密码！');
        return;
      }
      // let code = that.loginInfo.code;
      // if (!code) {
      //   that.$parent.showTost(0, '请输入验证码！');

      //   return;
      // }
      // if (code.toUpperCase() != that.imgLis[that.index]) {
      //   that.$parent.showTost(0, '验证码错误！');
      //   that.loginInfo.code = null;
      //   that.changIndex();
      //   return;
      // }

      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.showTost(0, res.message);
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          localStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/home');
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.outerdiv[data-v-65d98e59] {
    // background: url(../../static/img/regbg.ee97da33.jpg) no-repeat top;
    // background-size: cover
}

.regist[data-v-65d98e59] {
    width: 100%
}

.textlt[data-v-65d98e59] {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.registerDiv[data-v-65d98e59] {
    width: 100%;
    height: 100%;
    background-color: #e9ebf6;
    background-image: url('../../static/img/img_background.06890b5e.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    position: absolute;
    box-sizing: border-box
}

.registerDiv .gbline[data-v-65d98e59] {
    position: fixed;
    right: .26667rem;
    top: .26667rem;
    width: 1.06667rem
}

.registerDiv .getBack[data-v-65d98e59] {
    font-size: .4rem;
    text-align: center
}

.registerDiv .van_wrap_div[data-v-65d98e59] {
    width: 9.06667rem;
    margin: 0 auto;
    margin-top: 5.84rem;
    background: #fff;
    border-radius: .13333rem;
    padding: .26667rem .45333rem;
    padding-bottom: .8rem;
    box-sizing: border-box
}

.registerDiv .van_wrap_div .inputline[data-v-65d98e59]:after {
    content: ".";
    height: 0;
    visibility: hidden;
    display: block;
    clear: both
}

.registerDiv .van_wrap_div .inputline[data-v-65d98e59] {
    border-radius: .13333rem;
    margin-top: .26667rem;
    height: 1.22667rem;
    background-color: #fff;
    border: .02667rem solid #e3e4ea;
    position: relative;
    display: flex;
    align-items: center;
}

.registerDiv .van_wrap_div .inputline input[data-v-65d98e59] {
    width: 6.93333rem;
    padding-left: .4rem;
    float: left;
    text-align: left;
    line-height: 1.12rem;
    font-size: .37333rem;
    border: none;
    outline: none;
    left: .74667rem;
    top: .05333rem;
    position: absolute;
    z-index: 2;
    background: #fff
}

.registerDiv .van_wrap_div .inputline div[data-v-65d98e59] {
    width: 6.4rem;
    color: red;
    z-index: 1;
    padding-left: 0
}

.registerDiv .van_wrap_div .inputline .eye[data-v-65d98e59] {
    width: .42667rem;
    height: .21333rem;
    margin-right: .4rem;
    position: absolute;
    z-index: 3;
    right: 0
}

.registerDiv .van_wrap_div .inputline .iconImg[data-v-65d98e59] {
    width: .4rem;
    max-height: .4rem;
    margin-right: .4rem;
    margin-left: .4rem;
    z-index: 3;
    left: 0
}

.registerDiv .van_wrap_div .inputline .yzm{
    width: 1.89333rem;
    height: .66667rem;
    float: right;
    margin-right: .4rem;
    right: 0;
    position: absolute;
    z-index: 3
}

.registerDiv .van_wrap_div .sumbtns[data-v-65d98e59] {
    height: 1.2rem;
    color: #fff;
    width: 100%;
    background-color: #e3e4ea;
    border-radius: .21333rem;
    margin-top: .66667rem;
    font-size: .45333rem;
    font-weight: 700
}

.registerDiv .van_wrap_div .sumbtns .van-button--block[data-v-65d98e59] {
    width: 100%;
    background-color: #e3e4ea;
    border-radius: .21333rem;
    border: none
}

.registerDiv .van_wrap_div .submitActive[data-v-65d98e59] {
    opacity: 1;
    background-color: #4f8dfe
}

.registerDiv .van_wrap_div .submitActive .van-button--block[data-v-65d98e59] {
    background-color: #4f8dfe
}

.registerDiv .van_wrap_div .botline[data-v-65d98e59] {
    width: 100%;
    height: .37333rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    margin-top: .53333rem;
    text-align: center
}

.registerDiv .van_wrap_div .botline div[data-v-65d98e59] {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: .37333rem;
    color: #232323;
    font-size: .37333rem
}

[data-v-65d98e59] .van-field__error-message {
    display: none
}

[data-v-65d98e59] .van-button__text {
    font-size: .42667rem;
    font-weight: 700
}

.successPop[data-v-65d98e59] {
    width: 6.4rem;
    border-radius: .4rem;
    background-color: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
    padding-bottom: .8rem
}

.successPop .logo[data-v-65d98e59] {
    width: 1.6rem;
    height: 1.6rem;
    margin-top: .8rem
}

.successPop .btext[data-v-65d98e59],.successPop .tittle[data-v-65d98e59] {
    color: #232323;
    font-size: .37333rem;
    margin-top: .53333rem
}

.successPop .btext .seconds[data-v-65d98e59] {
    color: #4a71f0;
    margin-right: .02667rem
}

body content input:focus {
    outline: none
}

body input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 26.66667rem #fff inset
}
.van-cell:after{
    content: '';
    border: 0;
}

.gbline {
  position: absolute;
  right: .26667rem;
  top: .26667rem;
  width: 1.06667rem;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/reg.vue